<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0"> 

        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >

        <van-divider>队伍风采口号</van-divider>


        <van-cell-group>

            <van-field
                    v-model="formData.kouhao"
                    :rules="[]"
                    label="队伍口号"
                    maxlength="15"
                    show-word-limit
                    input-align="right"
                    autosize
                    type="textarea"
                    error-message-align="right"
                    clearable
                    placeholder="请输入队伍口号"
            /> 
            <van-cell title="队伍风采视频" :value="formData.fc_pic.length+'/1'">
                <template slot="icon" >
                    <van-icon class="question-icon" name="question-o" @click="onQuestion('heying')"/>
                </template>
            </van-cell>

            <div class="row">
                <PicUploader :fileList="formData.fc_pic" :limit="1"
                             :name="'fc_pic'"></PicUploader>
            </div>
            <div class="operate-desc-left">请上传队伍风采视频的二维码图片</div>
        </van-cell-group> 

            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">提交</van-button>
            </div>
        </van-form>
 

    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    
.bg-fapiao {
    height: 600px;
    width: 500px;
    background-size: 100%;
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    background: url(~@/assets/images/bg-fapiao.png) no-repeat;
    background-position-x: left;
    background-position-y: 250px;
    /* background-position: center; */
    background-size: 100%;
    position: relative;
    overflow: hidden;
}

.bg-fapiao .fapiao-title{
    color: #000;
    font-size: 12px;
    line-height: 12px;
    position: absolute;
    top: 297px;
    left: 91px;
    z-index: 10000;
}

.bg-fapiao .fapiao-goods{
    color: #000;
    font-size: 12px;
    line-height: 12px;
    position: absolute;
    top: 367px;
    left: 50px;
    z-index: 10000;
}
.bg-fapiao .fapiao-count{
    color: #000;
    font-size: 12px;
    line-height: 12px;
    position: absolute;
    top: 367px;
    left: 320px;
    z-index: 10000;
}
.bg-fapiao .fapiao-price{
    color: #000;
    font-size: 12px;
    line-height: 12px;
    position: absolute;
    top: 367px;
    left: 361px;
    z-index: 10000;
}
.bg-fapiao .fapiao-rate{
    color: #000;
    font-size: 12px;
    line-height: 12px;
    position: absolute;
    top: 367px;
    left: 415px;
    z-index: 10000;
}
.bg-fapiao .fapiao-duty{
    color: #000;
    font-size: 12px;
    line-height: 12px;
    position: absolute;
    top: 367px;
    left: 461px;
    z-index: 10000;
}
.bg-fapiao .fapiao-total{
    color: #000;
    font-size: 12px;
    line-height: 12px;
    position: absolute;
    top: 418px;
    left: 360px;
    z-index: 10000;
}
.fapiao-beizhu{
    color: #000;
    font-size: 12px;
    line-height: 12px;
    position: absolute;
    top: 446px;
    left: 340px;
    z-index: 10000;
}
.bg-fapiao .fapiao-total-cn{
    color: #000;
    font-size: 12px;
    line-height: 12px;
    position: absolute;
    top: 418px;
    left: 160px;
    z-index: 10000;
}
    .fapiao-tip-wrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        line-height: 36px;
        padding: 0.2rem;
        font-size: 14px;
        color: #666;
    }
    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button,Dialog} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';

    import PayDialog from '@/components/PayDialog.vue';
    import FapiaoPicker from "@/components/FapiaoPicker.vue"; 
    import { numToCapital } from "@/utils/utils.js";

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFapiao',
        components: {
            [Field.name]: Field,
            PicUploader,
            Dialog,
            PayDialog,
            FileUploader,
            FapiaoPicker,
        },
        data: function () {
            return {
                fapiaoPickerShow:false,
                validator,
                fapiao_show:false,
                loading:false,
                sheetActiveShow:false,
                showFapiao:false,
                payDialogShow:false,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                filename:'',
                fapiaoUrl:'',
                submitType:'',
                subjectName:'',
                orderIds:[],
                subjectArray:[],
                subjectOptions:[],
                formData:{
                    id:0,
                    kouhao:'',
                    fc_pic:[]
                },
                isApp:window.isApp()
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.formData.id = this.$route.query.id;
            document.title="队伍风采口号"
            if(that.formData.id){
                this.fetch();
            }
        },
        watch: { 
        },
        destroyed() {
        },
        methods: {  
            onQuestion(){
                console.log('onQuestion')
            }, 
            onSubmit(values){
                let that = this;
                
                // on confirm
                // console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);
                console.log(that.formData)
                that.formValidate = true; 
                that.saveLoading = true;

                that.$api.post('/api/isai/fcsave',{
                    id : that.formData.id,
                    kouhao : that.formData.kouhao, 
                    fc_pic : that.formData.fc_pic, 
                },(res) => {
                    that.saveLoading = false;
                    Toast('保存成功');
                    setTimeout(() =>{
                        rbLink({
                            name:'SaiApplyList'
                        },'back')
                    },2000);
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })

            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/isai/fcDetail', {
                    id:that.formData.id
                }, (res) => {
                    that.formData = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },      

        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyFormFc.vue?779a8514